export default "__VITE_ASSET__CFOOBEEI__"